<div class="reward-app-preview">
  <div class="reward-app-preview__phone">
    <div class="reward-app-preview__status-bar">
      <span class="reward-app-preview__status-time">9:41</span>
      <div class="reward-app-preview__status-icons">
        <svg width="17" height="11" viewBox="0 0 17 11" fill="white" xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true" focusable="false">
          <rect x="0" y="5" width="3" height="6" rx="1"/>
          <rect x="4.5" y="3" width="3" height="8" rx="1"/>
          <rect x="9" y="1" width="3" height="10" rx="1"/>
          <rect x="13.5" y="0" width="3" height="11" rx="1" fill-opacity="0.3"/>
        </svg>
        <svg width="15" height="11" viewBox="0 0 15 11" fill="white" xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true" focusable="false">
          <path d="M7.5 4C9.1 4 10.5 4.6 11.5 5.7L12.9 4.3C11.5 2.9 9.6 2 7.5 2C5.4 2 3.5 2.9 2.1 4.3L3.5 5.7C4.5 4.6 5.9 4 7.5 4Z"/>
          <path d="M7.5 6.5C8.4 6.5 9.2 6.9 9.7 7.5L11.1 6.1C10.2 5.1 8.9 4.5 7.5 4.5C6.1 4.5 4.8 5.1 3.9 6.1L5.3 7.5C5.8 6.9 6.6 6.5 7.5 6.5Z" fill-opacity="0.7"/>
          <circle cx="7.5" cy="10" r="1.5"/>
        </svg>
        <svg width="25" height="11" viewBox="0 0 25 11" fill="none" xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true" focusable="false">
          <rect x="0.5" y="0.5" width="21" height="10" rx="2" stroke="white" stroke-opacity="0.35"/>
          <rect x="22" y="3.5" width="2" height="4" rx="1" fill="white" fill-opacity="0.4"/>
          <rect x="2" y="2" width="17" height="7" rx="1.5" fill="white"/>
        </svg>
      </div>
    </div>
    <div class="reward-app-preview__screen">
      <span class="reward-app-preview__close" aria-hidden="true">&#x2715;</span>
      <svg class="reward-app-preview__logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" aria-label="Chick-fil-A">
        <path fill="#DD0031" d="M34.614 35.497c.473-1.967.768-3.973.88-5.993q.063-1.222 0-2.445c2.841.251 6.862 3.025 6.862 4.485s-2.542.348-7.733 3.953zM20.492 15.45c-1.933.87-4.727-1.285-6.118-4.32s-.725-5.606 1.16-6.476 4.291.309 5.683 3.334 1.16 6.592-.725 7.462m-5.645 2.697c-.966 1.14-3.412.648-5.17-.85-1.76-1.499-2.07-3.355-1.093-4.495s2.9-1.14 4.61.367c1.711 1.508 2.63 3.866 1.653 4.978m29.964-1.034c-4.195 3.112-9.666 3.953-11.599 1.382s.474-7.607 4.659-10.729c.348-.251.696-.483 1.034-.696a23.2 23.2 0 0 0-6.234-4.079 7.9 7.9 0 0 1 .464 5.365c-.87 4.01-3.721 7.345-6.235 6.766-2.513-.58-3.73-4.766-2.9-8.777A7.39 7.39 0 0 1 27.162 1.3 23.198 23.198 0 0 0 3.586 36.503c3.867-11.29 13.107-20.086 21.951-19.149 5.848.619 8.941 5.19 8.555 12.266-.387 6.902-3.432 13.61-7.51 17.495a23.2 23.2 0 0 0 18.635-30.37l-.425.33"></path><path fill="#DD0031" d="M26.563 25.764c1.247 0 1.276 1.12 1.266 1.614 0 2.088-2.59 4.649-3.866 2.687-.667-1.508.966-4.253 2.551-4.301zM12.306 42.002c.357-5.268 3.344-8.98 4.833-9.453a1.43 1.43 0 0 1 1.933 1.382c-.155 1.933-2.63 3.306-3.035 8.168-.194 2.242.59 4.833 3.073 4.92 5.384.3 10.478-9.995 10.865-17.05.338-6.09-1.866-8.893-5.055-9.203-7.627-.744-15.562 9.357-18.365 19.748a23.3 23.3 0 0 0 5.8 4.281 11.2 11.2 0 0 1-.136-2.793m32.09 6.331a2.716 2.716 0 1 1 .019-5.431 2.716 2.716 0 0 1-.02 5.431Zm0-6.099a3.383 3.383 0 1 0 3.373 3.383 3.39 3.39 0 0 0-3.373-3.383"></path><path fill="#DD0031" d="M43.739 46.158h.425q.173.011.338.058a.47.47 0 0 1 .28.261q.066.213.059.435.005.245.058.483h.966V47.3a.2.2 0 0 1 0-.106v-.417a.91.91 0 0 0-.328-.782 1.2 1.2 0 0 0-.542-.203c.238-.016.466-.1.658-.242a.73.73 0 0 0 .27-.638.85.85 0 0 0-.502-.83 2 2 0 0 0-.754-.194H42.84v3.547h.966zm.966-.763a.97.97 0 0 1-.54.125h-.388v-.986h.184a1.8 1.8 0 0 1 .57.068.416.416 0 0 1 .31.406.45.45 0 0 1-.194.416"></path>
      </svg>
      @if (primaryHeading) {
        <h1 class="reward-app-preview__title">{{ primaryHeading }}</h1>
      }
      @if (rewardProductName) {
        <p class="reward-app-preview__product-name">{{ rewardProductName }}</p>
      }
      <div class="reward-app-preview__product-img-wrapper">
        @if (rewardProductImageUrl) {
          <img class="reward-app-preview__product-img"
            [src]="rewardProductImageUrl"
            [alt]="rewardProductName"
            />
        }
      </div>
      @if (rewardGiftMessage) {
        <p class="reward-app-preview__message">{{ rewardGiftMessage }}</p>
      }
      @if (!hideGiftedSection) {
        <div class="reward-app-preview__gifted-section">
          @if (rewardOperatorImageUrl && includeOperatorPhoto) {
            <img class="reward-app-preview__operator-img"
              [src]="rewardOperatorImageUrl"
              alt="Operator"
              />
          }
          <span class="reward-app-preview__gifter-name">- {{ rewardOperatorName }}</span>
        </div>
      }
      <div class="reward-app-preview__spacer"></div>
      <button class="reward-app-preview__redeem-btn" disabled type="button">View in Rewards</button>
      <div class="reward-app-preview__legal">
        <span>Single Use only</span>
        <span>Valid through {{ rewardExpiryDate }}</span>
      </div>
    </div>
    <div class="reward-app-preview__home-indicator"></div>
  </div>
</div>
